/* globals wNumb */

import { initBootstrapSelect } from '../../Shared/js/vendor/deferred';

(function () {
    'use strict';

    // HACK: async/await doesn't work with jQuery here for some reason
    wo$(() =>
        initBootstrapSelect().then(() => {
            var filtersModal = null;
            var modalBackup = null;
            var modalDataBackup = null;
            var modalData = null;

            var phoneFiltersModalController = {
                registerNotifications: function () {
                    WhistleOut.notifications.add(function (notification, data) {
                        if (notification === 'FilterChanged') {
                            //if (data.type === 'Sort' || data.type === 'Widen' || data.type === 'Released') {
                            phoneFiltersModalController.updateModalData(data.criteria);
                            //}
                        }
                    });
                },
                bind: function () {
                    filtersModal.on('show.bs.modal', function () {
                        var searchInProgress = false;

                        phoneFiltersModalController.loadClientSideData();

                        phoneFiltersModalController.bindGenericSliders();
                        phoneFiltersModalController.bindCustomerType(filtersModal, modalData.customerType);
                        phoneFiltersModalController.bindNetworks(filtersModal, modalData.networks);
                        phoneFiltersModalController.bindSuppliers(filtersModal, modalData.suppliers);
                        phoneFiltersModalController.bindBrands(filtersModal, modalData.brands);
                        phoneFiltersModalController.bindPhonePriceTypes(filtersModal, modalData.priceTypes);
                        phoneFiltersModalController.bindOperatingSystems(filtersModal, modalData.operatingSystems);
                        phoneFiltersModalController.bindSortExpressions(filtersModal, modalData.sortExpressions);
                        phoneFiltersModalController.bindReleasedIn(filtersModal, modalData.releasedInPeriods);
                        phoneFiltersModalController.bindOtherOptions(filtersModal, modalData.otherOptions);
                        phoneFiltersModalController.bindPlanTypes(filtersModal, modalData);
                        WhistleOut.applySelectPickersStyle(filtersModal);

                        filtersModal.find('button[name="modal-search"]').click(function () {
                            searchInProgress = true;
                            WhistleOut.setLookupData(filtersModal.parent(), wo$.extend(true, {}, modalData));
                            phoneFiltersModalController.search();
                        });
                        filtersModal.find('button[name="modal-cancel"]').click(function () {
                            filtersModal.modal('hide');
                        });
                        filtersModal.on('hidden.bs.modal', function () {
                            wo$('div[data-toggle="popover"]').each(function () {
                                var $this = wo$(this);
                                $this.popover('hide');
                            });
                            filtersModal.html(modalBackup);
                            filtersModal.off('hidden.bs.modal');
                        });
                        filtersModal.on('hide.bs.modal', function () {
                            if (searchInProgress === false) {
                                WhistleOut.setLookupData(filtersModal.parent(), wo$.extend(true, {}, modalDataBackup));
                            }
                            wo$('html, body').removeClass('modal-open');
                            wo$('.modal-backdrop').remove();

                            filtersModal.off('hide.bs.modal');
                        });
                        filtersModal.find('#select-all-suppliers').click(function () {
                            wo$.each(modalData.suppliers, function (index, supplier) {
                                supplier.isChecked = true;
                            });
                            wo$.each(modalData.networks, function (index, network) {
                                network.isChecked = true;
                                filtersModal.find('#network-' + network.id).prop('checked', true);
                            });
                            filtersModal.find('#personal-checkbox').prop('checked', true);
                            filtersModal.find('#business-checkbox').prop('checked', true);
                            phoneFiltersModalController.bindSuppliers(filtersModal, modalData.suppliers);
                        });
                        filtersModal.find('#unselect-all-suppliers').click(function () {
                            wo$.each(modalData.suppliers, function (index, supplier) {
                                supplier.isChecked = false;
                            });
                            phoneFiltersModalController.bindSuppliers(filtersModal, modalData.suppliers);
                        });
                        filtersModal.find('#personal-checkbox').click(function () {
                            var showPersonal = filtersModal.find('#personal-checkbox').is(':checked');
                            var showBusiness = filtersModal.find('#business-checkbox').is(':checked');

                            wo$.each(modalData.suppliers, function (index, supplier) {
                                if (!showBusiness && !showPersonal) {
                                    supplier.isChecked = false;
                                } else if (showPersonal && supplier.isPersonal) {
                                    supplier.isChecked = true;
                                } else if (!showPersonal && supplier.isPersonal && !supplier.isBusiness) {
                                    supplier.isChecked = false;
                                }
                            });
                            phoneFiltersModalController.bindSuppliers(filtersModal, modalData.suppliers);

                            if ((showPersonal && showBusiness) || (!showPersonal && !showBusiness)) {
                                modalData.customerType = null;
                            } else if (showPersonal) {
                                modalData.customerType = 'Personal';
                            } else if (showBusiness) {
                                modalData.customerType = 'Business';
                            }
                        });
                        filtersModal.find('#business-checkbox').click(function () {
                            var showPersonal = filtersModal.find('#personal-checkbox').is(':checked');
                            var showBusiness = filtersModal.find('#business-checkbox').is(':checked');

                            wo$.each(modalData.suppliers, function (index, supplier) {
                                if (!showBusiness && !showPersonal) {
                                    supplier.isChecked = false;
                                } else if (showBusiness && supplier.isBusiness) {
                                    supplier.isChecked = true;
                                } else if (!showBusiness && supplier.isBusiness & !supplier.isPersonal) {
                                    supplier.isChecked = false;
                                }
                            });
                            phoneFiltersModalController.bindSuppliers(filtersModal, modalData.suppliers);

                            if ((showPersonal && showBusiness) || (!showPersonal && !showBusiness)) {
                                modalData.customerType = null;
                            } else if (showPersonal) {
                                modalData.customerType = 'Personal';
                            } else if (showBusiness) {
                                modalData.customerType = 'Business';
                            }
                        });
                        filtersModal.find('#select-all-brands').click(function () {
                            wo$.each(modalData.brands, function (index, brand) {
                                brand.isChecked = true;
                            });
                            phoneFiltersModalController.bindBrands(filtersModal, modalData.brands);
                        });
                        filtersModal.find('#unselect-all-brands').click(function () {
                            wo$.each(modalData.brands, function (index, brand) {
                                brand.isChecked = false;
                            });
                            phoneFiltersModalController.bindBrands(filtersModal, modalData.brands);
                        });
                        filtersModal.find('#select-all-os').click(function () {
                            wo$.each(modalData.operatingSystems, function (index, os) {
                                os.isChecked = true;
                            });
                            phoneFiltersModalController.bindOperatingSystems(filtersModal, modalData.operatingSystems);
                        });
                        filtersModal.find('#unselect-all-os').click(function () {
                            wo$.each(modalData.operatingSystems, function (index, os) {
                                os.isChecked = false;
                            });
                            phoneFiltersModalController.bindOperatingSystems(filtersModal, modalData.operatingSystems);
                        });
                        var tab = filtersModal.data('tab');
                        if (tab) {
                            var tabToShow = filtersModal.find('a[href="#' + tab + '"]');
                            tabToShow.tab('show');
                            filtersModal.data('tab', null);
                        }

                        filtersModal.find('[data-screen]').click(function () {
                            var $this = wo$(this);

                            // TODO: Handle missing slider values

                            var min = !$this.data('min')
                                ? 0
                                : modalData.screenSlider.pegs.filter(function (p) {
                                      return p.value === $this.data('min');
                                  })[0].index;

                            var max = !$this.data('max')
                                ? modalData.screenSlider.pegs.length - 1
                                : modalData.screenSlider.pegs.filter(function (p) {
                                      return p.value === $this.data('max');
                                  })[0].index;

                            filtersModal.find('[data-modal-screen-slider]').val([min, max]);
                        });

                        filtersModal.find('[data-camera]').click(function () {
                            var value = wo$(this).data('value');

                            // TODO: Handle missing slider values
                            var index = modalData.cameraSlider.pegs.filter(function (p) {
                                return p.value === value;
                            })[0].index;

                            filtersModal.find('[data-modal-camera-slider]').val(index);
                        });

                        filtersModal.find('[data-data]').click(function () {
                            const value = wo$(this).data('data');
                            const matches = modalData.modalDataSlider.pegs.filter(function (p) {
                                return p.value === value;
                            });

                            if (matches.length <= 0) {
                                console.warn(`Missing data slider value: ${value}`);
                            }

                            const index = matches[0]?.index;
                            filtersModal.find('[data-modal-data-slider]').val(index);
                        });
                    });
                },

                loadClientSideData: function () {
                    modalDataBackup = wo$.extend(true, {}, WhistleOut.readLookupData(filtersModal.parent()));
                    modalData = WhistleOut.readLookupData(filtersModal.parent());
                },

                bindGenericSliders: function () {
                    phoneFiltersModalController.bindMaxPhoneUpfrontSlider(
                        filtersModal,
                        modalData.maxPhoneUpfrontSlider
                    );
                    phoneFiltersModalController.bindSpendSlider(filtersModal, modalData.monthlySpendSlider);
                    phoneFiltersModalController.bindCameraSlider(filtersModal, modalData.cameraSlider);
                    phoneFiltersModalController.bindScreenSlider(filtersModal, modalData.screenSlider);
                    phoneFiltersModalController.bindDataSlider(filtersModal, modalData.modalDataSlider);
                },

                bindMaxPhoneUpfrontSlider: function (container, sliderConfig, rebind) {
                    WhistleOut.createSlider(
                        container.find('[data-modal-maxupfront-slider]'),
                        container.find('[data-modal-maxupfront-text]'),
                        sliderConfig,
                        wNumb({ decimals: 0 }),
                        null,
                        rebind
                    );
                },

                bindCameraSlider: function (container, sliderConfig, rebind) {
                    WhistleOut.createSlider(
                        container.find('[data-modal-camera-slider]'),
                        container.find('[data-modal-camera-text]'),
                        sliderConfig,
                        wNumb({ decimals: 0 }),
                        null,
                        rebind
                    );
                },

                bindSpendSlider: function (container, sliderConfig, rebind) {
                    WhistleOut.createSlider(
                        container.find('[data-modal-spend-slider]'),
                        container.find('[data-modal-spend-text]'),
                        sliderConfig,
                        wNumb({ decimals: 0 }),
                        null,
                        rebind
                    );
                },

                bindScreenSlider: function (container, sliderConfig) {
                    WhistleOut.createDoubleSlider(
                        container.find('[data-modal-screen-slider]'),
                        container.find('[data-modal-minscreen-text]'),
                        sliderConfig,
                        wNumb({ decimals: 0 }),
                        null,
                        container.find('[data-modal-maxscreen-text]')
                    );
                },

                bindDataSlider: function (container, sliderConfig, rebind) {
                    WhistleOut.createSlider(
                        container.find('[data-modal-data-slider]'),
                        container.find('[data-modal-data-text]'),
                        sliderConfig,
                        wNumb({ decimals: 0 }),
                        null,
                        rebind
                    );
                },

                bindCustomerType: function (container, customerType) {
                    container.find('#personal-checkbox').prop('checked', true);
                    container.find('#business-checkbox').prop('checked', true);

                    if (customerType === 'Personal') {
                        container.find('#business-checkbox').prop('checked', false);
                    } else if (customerType === 'Business') {
                        container.find('#personal-checkbox').prop('checked', false);
                    }
                },

                bindNetworks: function (container, networks) {
                    container.find('[data-network-checkbox]').each(function () {
                        var input = wo$(this);
                        var id = input.data('network-checkbox');
                        var isChecked = networks.filter(function (network) {
                            return network.id === id;
                        })[0].isChecked;
                        input.prop('checked', isChecked);

                        input.click(function () {
                            var networkId = wo$(this).data('network-checkbox');
                            var isChecked = wo$(this).is(':checked');

                            wo$.each(modalData.networks, function (index, network) {
                                if (network.id === networkId) {
                                    network.isChecked = isChecked;
                                }
                            });

                            var suppliersOnSelectedNetwork = modalData.suppliers.filter(function (s) {
                                return s.networkIds.indexOf(networkId) > -1;
                            });

                            if (isChecked) {
                                wo$.each(suppliersOnSelectedNetwork, function (index, supplier) {
                                    supplier.isChecked = true;
                                });
                            } else {
                                var otherSelectedNetworkIds = wo$.map(
                                    modalData.networks.filter(function (n) {
                                        return n.isChecked === true;
                                    }),
                                    function (n) {
                                        return n.id;
                                    }
                                );
                                wo$.each(suppliersOnSelectedNetwork, function (index, supplier) {
                                    var hasOtherNetworks =
                                        supplier.networkIds.filter(function (n) {
                                            return otherSelectedNetworkIds.indexOf(n) !== -1;
                                        }).length > 0;
                                    if (!hasOtherNetworks) {
                                        supplier.isChecked = isChecked;
                                    }
                                });
                            }

                            phoneFiltersModalController.bindSuppliers(filtersModal, modalData.suppliers);
                        });
                    });
                },

                bindSuppliers: function (container, suppliers) {
                    container.find('.suppliers').each(function () {
                        var input = wo$(this);
                        var shortUrl = input.attr('id');
                        var isChecked = suppliers.filter(function (supplier) {
                            return supplier.shortUrl === shortUrl;
                        })[0].isChecked;
                        input.prop('checked', isChecked);

                        input.click(function () {
                            var showPersonal = filtersModal.find('#personal-checkbox').is(':checked');
                            var showBusiness = filtersModal.find('#business-checkbox').is(':checked');
                            wo$.each(suppliers, function (index, supplier) {
                                if (shortUrl === supplier.shortUrl) {
                                    supplier.isChecked = input.is(':checked');
                                    if (
                                        supplier.isBusiness &&
                                        !supplier.isPersonal &&
                                        !showBusiness &&
                                        supplier.isChecked
                                    ) {
                                        filtersModal.find('#business-checkbox').prop('checked', true);
                                    }
                                    if (supplier.isPersonal && !showPersonal && supplier.isChecked) {
                                        filtersModal.find('#personal-checkbox').prop('checked', true);
                                    }
                                    wo$.each(modalData.networks, function (i, n) {
                                        if (
                                            supplier.networkIds.filter(function (nid) {
                                                return n.id === nid;
                                            }).length > 0
                                        ) {
                                            var networkId = n.id;
                                            if (supplier.isChecked === true) {
                                                n.isChecked = true;
                                                filtersModal.find('#network-' + networkId).prop('checked', true);
                                            }
                                        }
                                    });
                                }
                            });

                            showPersonal = filtersModal.find('#personal-checkbox').is(':checked');
                            showBusiness = filtersModal.find('#business-checkbox').is(':checked');
                            if ((showPersonal && showBusiness) || (!showPersonal && !showBusiness)) {
                                modalData.customerType = null;
                            } else if (showPersonal) {
                                modalData.customerType = 'Personal';
                            } else if (showBusiness) {
                                modalData.customerType = 'Business';
                            }
                        });

                        var showPersonal = filtersModal.find('#personal-checkbox').is(':checked');
                        var showBusiness = filtersModal.find('#business-checkbox').is(':checked');
                        if ((showPersonal && showBusiness) || (!showPersonal && !showBusiness)) {
                            modalData.customerType = null;
                        } else if (showPersonal) {
                            modalData.customerType = 'Personal';
                        } else if (showBusiness) {
                            modalData.customerType = 'Business';
                        }
                    });
                },

                bindBrands: function (container, brands) {
                    container.find('[data-brand-checkbox]').each(function () {
                        var input = wo$(this);
                        var shortUrl = input.data('brand-checkbox');
                        var isChecked = brands.filter(function (brand) {
                            return brand.shortUrl === shortUrl;
                        })[0].isChecked;
                        input.prop('checked', isChecked);

                        input.click(function () {
                            wo$.each(brands, function (index, brand) {
                                if (shortUrl === brand.shortUrl) {
                                    brand.isChecked = input.is(':checked');
                                }
                            });
                        });
                    });
                },

                bindPhonePriceTypes: function (container, priceTypes) {
                    container.find('[data-price-type-checkbox]').each(function () {
                        var input = wo$(this);
                        var value = input.data('price-type-checkbox');
                        var isChecked = priceTypes.filter(function (priceType) {
                            return priceType.value === value;
                        })[0].isChecked;
                        input.prop('checked', isChecked);

                        input.click(function () {
                            wo$.each(priceTypes, function (index, priceType) {
                                if (value === priceType.value) {
                                    priceType.isChecked = input.is(':checked');
                                }
                            });
                        });
                    });
                    //var select = container.find('#price-types');
                    //WhistleOut.applySelectPicker(select);

                    //var checkedPriceTypes = priceTypes.filter(function (priceType) {
                    //    return priceType.isChecked;
                    //});
                    //var checkedPriceTypeValues = checkedPriceTypes.map(function (priceType) {
                    //    return priceType.value;
                    //});
                    //select.selectpicker('val', checkedPriceTypeValues);
                    //select.off('changed.bs.select').on('changed.bs.select', function () {
                    //    var values = select.selectpicker('val');
                    //    wo$(priceTypes).each(function (index, priceType) {
                    //        priceType.isChecked = values != null && values.indexOf(priceType.value) !== -1;
                    //    });
                    //});
                },

                bindOperatingSystems: function (container, operatingSystems) {
                    container.find('[data-os-checkbox]').each(function () {
                        var input = wo$(this);
                        var shortUrl = input.data('os-checkbox');
                        var isChecked = operatingSystems.filter(function (operatingSystem) {
                            return operatingSystem.shortUrl === shortUrl;
                        })[0].isChecked;
                        input.prop('checked', isChecked);

                        input.click(function () {
                            wo$.each(operatingSystems, function (index, operatingSystem) {
                                if (shortUrl === operatingSystem.shortUrl) {
                                    operatingSystem.isChecked = input.is(':checked');
                                }
                            });
                        });
                    });
                },

                bindSortExpressions: function (container, data) {
                    var select = container.find('select[id="sort-by"]');
                    WhistleOut.applySelectPicker(select);
                    var selectedSortExpression = data.filter(function (sortExpression) {
                        return sortExpression.isChecked === true;
                    })[0];

                    if (selectedSortExpression) {
                        phoneFiltersModalController.selectSortExpression(container, data, selectedSortExpression.key);
                    }

                    select.change(function () {
                        var selectedKey = this.value;
                        phoneFiltersModalController.selectSortExpression(container, data, selectedKey);
                    });
                },

                bindReleasedIn: function (container, data) {
                    var select = container.find('select[id="released-in"]');
                    WhistleOut.applySelectPicker(select);
                    var selectedReleasedIn = data.filter(function (releasedIn) {
                        return releasedIn.isChecked === true;
                    })[0];

                    if (selectedReleasedIn) {
                        phoneFiltersModalController.selectReleasedIn(container, data, selectedReleasedIn.key);
                    }

                    select.change(function () {
                        var selectedKey = this.value;
                        phoneFiltersModalController.selectReleasedIn(container, data, selectedKey);
                    });
                },

                bindPlanTypes: function (container, data) {
                    var selectedPlanType = data.planType ? data.planType : '';
                    var select = container.find('select[id="plan-type"]');
                    WhistleOut.applySelectPicker(select);
                    select.selectpicker('val', selectedPlanType);
                    select.change(function () {
                        var planType = this.value;
                        switch (planType) {
                            case '':
                                data.planType = null;
                                break;
                            default:
                                data.planType = planType;
                                break;
                        }
                    });
                },

                bindOtherOptions: function (container, otherOptions) {
                    var select = container.find('select[id="other-options"]');
                    WhistleOut.applySelectPicker(select);

                    var checkedOtherOptions = otherOptions.filter(function (option) {
                        return option.isChecked === true;
                    });
                    var checkedOtherOptionKeys = checkedOtherOptions.map(function (option) {
                        return option.key;
                    });
                    select.selectpicker('val', checkedOtherOptionKeys);
                    select.off('changed.bs.select').on('changed.bs.select', function () {
                        var values = select.selectpicker('val');
                        wo$(otherOptions).each(function (index, option) {
                            option.isChecked = values != null && values.indexOf(option.key) !== -1;
                        });
                    });
                },

                selectSortExpression: function (container, data, key) {
                    if (!key) {
                        key = -1;
                    }

                    wo$.each(data, function (index, sortExpression) {
                        sortExpression.isChecked = false;
                    });

                    var selectedSortExpression = data.filter(function (sortExpression) {
                        return sortExpression.key === key;
                    })[0];

                    if (selectedSortExpression) {
                        selectedSortExpression.isChecked = true;
                        var select = container.find('select[id="sort-by"]');
                        select.selectpicker('val', selectedSortExpression.key);
                    }
                },

                selectReleasedIn: function (container, data, key) {
                    if (!key) {
                        key = -1;
                    }

                    wo$.each(data, function (index, releasedIn) {
                        releasedIn.isChecked = false;
                    });

                    var selectedReleasedIn = data.filter(function (releasedIn) {
                        return releasedIn.key === key;
                    })[0];

                    if (selectedReleasedIn) {
                        selectedReleasedIn.isChecked = true;
                        var select = container.find('select[id="released-in"]');
                        select.selectpicker('val', selectedReleasedIn.key);
                    }
                },

                updateModalData: function (data) {
                    wo$.each(modalData.sortExpressions, function (i, e) {
                        var sort = data.sortExpression;
                        if (!data.sortAscending) {
                            sort += '-desc';
                        }
                        e.isChecked = e.key === sort;
                    });
                    wo$.each(modalData.brands, function (i, e) {
                        e.isChecked = data.brands.length === 0 || wo$.inArray(e.shortUrl, data.brands) >= 0;
                    });
                    wo$.each(modalData.operatingSystems, function (i, e) {
                        e.isChecked =
                            data.operatingSystems.length === 0 || wo$.inArray(e.shortUrl, data.operatingSystems) >= 0;
                    });

                    wo$.each(modalData.suppliers, function (i, e) {
                        e.isChecked = data.suppliers.length === 0 || wo$.inArray(e.shortUrl, data.suppliers) >= 0;
                    });
                    wo$.each(modalData.networks, function (i, e) {
                        e.isChecked = data.networks.length === 0 || wo$.inArray(e.id, data.networks) >= 0;
                    });
                    modalData.cameraSlider.currentPeg =
                        data.camera == null
                            ? modalData.cameraSlider.pegs[0]
                            : modalData.cameraSlider.pegs.filter(function (p) {
                                  return p.value === data.camera;
                              })[0];
                    modalData.modalDataSlider.currentPeg =
                        data.minData == null
                            ? modalData.modalDataSlider.pegs[0]
                            : modalData.modalDataSlider.pegs.filter(function (p) {
                                  return p.value === data.minData;
                              })[0];
                    modalData.screenSlider.currentPeg1 =
                        data.minScreen == null
                            ? modalData.screenSlider.pegs[0]
                            : modalData.screenSlider.pegs.filter(function (p) {
                                  return p.value === data.minScreen;
                              })[0];
                    modalData.screenSlider.currentPeg2 =
                        data.maxScreen == null
                            ? modalData.screenSlider.pegs[modalData.screenSlider.pegs.length - 1]
                            : modalData.screenSlider.pegs.filter(function (p) {
                                  return p.value === data.maxScreen;
                              })[0];
                    modalData.monthlySpendSlider.currentPeg =
                        data.maxSpend == null
                            ? modalData.monthlySpendSlider.pegs[modalData.monthlySpendSlider.pegs.length - 1]
                            : modalData.monthlySpendSlider.pegs.filter(function (p) {
                                  return p.value === data.maxSpend;
                              })[0];
                    modalData.maxPhoneUpfrontSlider.currentPeg =
                        data.maxUpfront == null
                            ? modalData.maxPhoneUpfrontSlider.pegs[modalData.maxPhoneUpfrontSlider.pegs.length - 1]
                            : modalData.maxPhoneUpfrontSlider.pegs.filter(function (p) {
                                  return p.value === data.maxUpfront;
                              })[0];
                    modalData.planType = data.planType;
                    wo$.each(modalData.priceTypes, function (i, e) {
                        e.isChecked = data.priceTypes.length === 0 || wo$.inArray(e.value, data.priceTypes) >= 0;
                    });
                    wo$.each(modalData.otherOptions, function (i, e) {
                        switch (e.key) {
                            case 'singlePhonePerBrand':
                                e.isChecked = data.singlePhonePerBrand === true;
                                break;
                            case 'showEditorsPicksOnly':
                                e.isChecked = data.showEditorsPicksOnly === true;
                                break;
                            case 'show5G':
                                e.isChecked = data.show5G === true;
                                break;
                            case 'showESim':
                                e.isChecked = data.showESim === true;
                                break;
                            case 'showTelstraBlueTickOnly':
                                e.isChecked = data.showTelstraBlueTickOnly === true;
                                break;
                            case 'optusRegionalPickOnly':
                                e.isChecked = data.optusRegionalPickOnly === true;
                                break;
                        }
                    });
                    wo$.each(modalData.releasedInPeriods, function (i, e) {
                        if (e.key.length === 0 && !data.released) e.isChecked = true;
                        else e.isChecked = e.key.length > 0 && data.released === parseInt(e.key);
                    });
                    WhistleOut.setLookupData(filtersModal.parent(), wo$.extend(true, {}, modalData));
                },

                // eslint-disable-next-line complexity
                search: function () {
                    filtersModal.find('button[name="modal-search"]').attr('disabled', 'disabled');
                    filtersModal.find('button[name="modal-cancel"]').attr('disabled', 'disabled');
                    filtersModal.find('span[name="modal-search-spinner"]').show();

                    var queryData = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                    queryData.maxSpend = modalData.monthlySpendSlider.currentPeg.value;
                    queryData.maxUpfront = modalData.maxPhoneUpfrontSlider.currentPeg.value;
                    queryData.camera = modalData.cameraSlider.currentPeg.value;
                    queryData.minData = modalData.modalDataSlider.currentPeg.value;
                    queryData.minScreen = modalData.screenSlider.currentPeg1.value;
                    queryData.maxScreen = modalData.screenSlider.currentPeg2.value;
                    queryData.suppliers = modalData.suppliers
                        .filter(function (s) {
                            return s.isChecked === true;
                        })
                        .map(function (s) {
                            return s.shortUrl;
                        });
                    if (queryData.suppliers.length === modalData.suppliers.length) queryData.suppliers = [];
                    queryData.networks = modalData.networks
                        .filter(function (s) {
                            return s.isChecked === true;
                        })
                        .map(function (s) {
                            return s.id;
                        });
                    if (queryData.networks.length === modalData.networks.length) queryData.networks = [];
                    queryData.brands = modalData.brands
                        .filter(function (s) {
                            return s.isChecked === true;
                        })
                        .map(function (s) {
                            return s.shortUrl;
                        });
                    if (queryData.brands.length === modalData.brands.length) queryData.brands = [];
                    queryData.priceTypes = modalData.priceTypes
                        .filter(function (s) {
                            return s.isChecked === true;
                        })
                        .map(function (s) {
                            return s.value;
                        });
                    if (queryData.priceTypes.length === modalData.priceTypes.length) queryData.priceTypes = [];
                    var otherOptions = modalData.otherOptions
                        .filter(function (s) {
                            return s.isChecked === true;
                        })
                        .map(function (s) {
                            return s.key;
                        });
                    if (
                        otherOptions.filter(function (o) {
                            return o === 'singlePhonePerBrand';
                        }).length
                    )
                        queryData.singlePhonePerBrand = true;
                    else queryData.singlePhonePerBrand = null;
                    if (
                        otherOptions.filter(function (o) {
                            return o === 'showEditorsPicksOnly';
                        }).length
                    )
                        queryData.showEditorsPicksOnly = true;
                    else queryData.showEditorsPicksOnly = null;
                    if (
                        otherOptions.filter(function (o) {
                            return o === 'show5G';
                        }).length
                    )
                        queryData.show5G = true;
                    else queryData.show5G = null;
                    if (
                        otherOptions.filter(function (o) {
                            return o === 'showESim';
                        }).length
                    )
                        queryData.showESim = true;
                    else queryData.showESim = null;
                    if (
                        otherOptions.filter(function (o) {
                            return o === 'showTelstraBlueTickOnly';
                        }).length
                    )
                        queryData.showTelstraBlueTickOnly = true;
                    else queryData.showTelstraBlueTickOnly = null;
                    if (
                        otherOptions.filter(function (o) {
                            return o === 'optusRegionalPickOnly';
                        }).length
                    )
                        queryData.optusRegionalPickOnly = true;
                    else queryData.optusRegionalPickOnly = null;
                    queryData.operatingSystems = modalData.operatingSystems
                        .filter(function (s) {
                            return s.isChecked === true;
                        })
                        .map(function (s) {
                            return s.shortUrl;
                        });
                    if (queryData.operatingSystems.length === modalData.operatingSystems.length)
                        queryData.operatingSystems = [];
                    var selectedSortExpression = modalData.sortExpressions.filter(function (sortExpression) {
                        return sortExpression.isChecked === true;
                    })[0];

                    if (selectedSortExpression) {
                        queryData.sortExpression = selectedSortExpression.key.replace('-desc', '');
                        queryData.sortAscending = selectedSortExpression.isAscending;
                    } else {
                        queryData.sortExpression = null;
                        queryData.sortAscending = true;
                    }
                    var selectedReleasedIn = modalData.releasedInPeriods.filter(function (releasedIn) {
                        return releasedIn.isChecked === true;
                    })[0];

                    if (selectedReleasedIn) {
                        queryData.released = selectedReleasedIn.key;
                    } else {
                        queryData.released = null;
                    }
                    if (modalData.planType) {
                        queryData.planType = modalData.planType;
                    }

                    if (modalData.customerType) {
                        queryData.customer = modalData.customerType;

                        if (
                            modalData.customerType === 'Personal' &&
                            queryData.suppliers &&
                            queryData.suppliers.length > 0
                        ) {
                            var allPersonalSuppliers = modalData.allSuppliers
                                .filter(function (s) {
                                    return s.isPersonal;
                                })
                                .map(function (s) {
                                    return s.shortUrl;
                                });
                            // Selected all personal suppliers only
                            if (
                                wo$(allPersonalSuppliers).not(queryData.suppliers).length === 0 &&
                                wo$(queryData.suppliers).not(allPersonalSuppliers).length === 0
                            ) {
                                queryData.suppliers = [];
                            }
                        } else if (
                            modalData.customerType === 'Business' &&
                            queryData.suppliers &&
                            queryData.suppliers.length > 0
                        ) {
                            var allBusinessSuppliers = modalData.allSuppliers
                                .filter(function (s) {
                                    return s.isBusiness;
                                })
                                .map(function (s) {
                                    return s.shortUrl;
                                });
                            // Selected all personal suppliers only
                            if (
                                wo$(allBusinessSuppliers).not(queryData.suppliers).length === 0 &&
                                wo$(queryData.suppliers).not(allBusinessSuppliers).length === 0
                            ) {
                                queryData.suppliers = [];
                            }
                        }
                    } else queryData.customer = null;

                    if (modalData.tab && modalData.tab.length) {
                        queryData.tab = modalData.tab;
                    }

                    filtersModal.modal('hide');
                    WhistleOut.notifications.fire('FilterChanged', { criteria: queryData });

                    // Scroll To Top
                    if (wo$ !== undefined && wo$) {
                        WhistleOut.scrollTo('.navbar');
                    }
                },

                init: function () {
                    filtersModal = wo$('#modal-finder-filters');
                    if (!filtersModal.length) return;

                    modalBackup = filtersModal.clone().html();
                    modalDataBackup = wo$.extend(true, {}, WhistleOut.readLookupData(filtersModal.parent()));
                    modalData = WhistleOut.readLookupData(filtersModal.parent());

                    phoneFiltersModalController.bind();
                    phoneFiltersModalController.registerNotifications();
                }
            };

            WhistleOut.initModule(import.meta.url, phoneFiltersModalController.init);
        })
    );
})();
